module.exports = __webpack_public_path__ + "static/media/cpaipw-2026-logo.4eccde13.svg";